export default "__VITE_ASSET__1hRv0VjY__"